<template>
  <div class="pilot-box" :class="{ 'pilot-flex': navMax, 'pilot-loading': loading }">
    <div class="new-popupbox box-loading" v-if="loading">
      <a-spin tip="正在读取教材内容，请稍后..." size="large" wrapperClassName="box-spin" />
    </div>

    <a-empty class="empty-box" :image="simpleImage" v-if="intList.length == 0" />
    <!-- 菜单 -->
    <div class="nav-fold-box" @mouseenter="mouseEvent(false)" @click="mouseEvent(false)">
      <div class="icon-omit-box" v-if="!navMax">
        <svg class="icon-omit">
          <use xlink:href="#icon-bar" />
        </svg>
      </div>
    </div>
    <pilotNav :class="{ fold: navFold, navMax: navMax }" @openCode="openCode($event)"
      @switchChapter="switchChapter($event, 'chapter')" @mouseleave="mouseEvent(true)" @swichNavMax="swichNavMax($event)"
      @foldNav="foldNav($event)">
    </pilotNav>
    <noteBox :chapter_num="chapter_num" :allNote="allNote" :noteData="noteData"
      @switchChapter="switchChapter($event, 'chapter')" @chooseCode="chooseCode($event)" v-if="!loadNote"></noteBox>
    <questionBox :chapter_num="chapter_num" :allNote="allNote" :questionData="questionData" v-if="!loadNote">
    </questionBox>
    <pilot-achievement></pilot-achievement>

    <!-- 具体内容 -->
    <div class="pilot-content-box" @click="mouseEvent(true)">
      <div class="pilot-content">
        <div class="int-item" :id="int.PK_InductionGuid" :class="{ 'active': int.chapter_num == chapter_num }"
          v-for="int in intList">
          <div v-if="int.show">
            <div class="int-name">{{ int.InductionName }}</div>
            <div class="int-des" v-if="int.Description">{{ int.Description }}</div>
            <div class="paragraph" v-for="cint of int.children ">
              <div class="cint-title" :class="{ hide: int.children.length == 1 }">{{ cint.InductionName }}</div>
              <div class="list-box">
                <div class="list-item-box" :id="code.Guid"
                  :class="{ lastSubmit: code.isLastSubmit, fold: code.fold, fullType: code.ProjectCode == 'kd', smallType: (code.ProjectCode == 'kb') }, code.Guid"
                  :style="{ height: !code.fold ? code.height + 'px' : 'auto' }" v-for=" code of cint.data "
                  @click="openCode(code)">
                  <div class="code-handler">
                    <div class="icon-fold-box" @click.stop="foldCode(code)" v-if="code.fold">
                      <svg class="icon-fold">
                        <use xlink:href="#icon-unfold" />
                      </svg>
                      <span class="icon-text">展开</span>
                    </div>
                    <a-tooltip placement="right" v-if="!code.fold && code.ProjectCode != 'kd'">
                      <template #title>折叠</template>
                      <div class="icon-fold-box" @click.stop="foldCode(code)">
                        <svg class="icon-fold" v-if="!code.fold">
                          <use xlink:href="#icon-fold" />
                        </svg>
                      </div>
                    </a-tooltip>
                    <a-tooltip placement="right"
                      v-if="!code.fold && code.ProjectCode != 'kb' && code.ProjectCode != 'kd'">
                      <template #title>全屏</template>
                      <div class="icon-fold-box" @click.stop="openIframe(code)">
                        <svg class="icon-fold" v-if="!code.fold">
                          <use xlink:href="#icon-quanping" />
                        </svg>
                      </div>
                    </a-tooltip>
                  </div>
                  <div class="list-item" v-if="code.fold">
                    <svg class="icon-svg code-icon">
                      <use :xlink:href="code.icon" />
                    </svg>
                    <div class="code-name">{{ code.typeName }}：{{ code.Title }}</div>
                    <div class="code-hanlder">
                      <svg class="icon-svg code-icon" v-if="code.isSubmited">
                        <use xlink:href="#icon-duihao" />
                      </svg>
                      <span class="code-noSubmited" v-if="!code.isSubmited">待完成</span>
                    </div>
                  </div>
                  <iframe class="iframe-content" :ref="code.Guid" :src="code.phoneIframe"  allowfullscreen="true" scrolling="no" frameborder="0"
                    name="ifd" :style="{ height: code.height + 'px', ...code.style }" @load="listenIframe(code)"
                    v-if="!code.fold"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pilot-page">
        <!-- <div class="page-button" v-if="chapter_num > 0" @click="switchChapter(chapter_num - 1, 'chapter')">
          <svg class="icon-svg icon-last">
            <use xlink:href="#icon-last" />
          </svg>
          <span class="page-text">上一单元</span>
        </div> -->

        <div class="page-button" v-if="chapter_num < intList.length - 1"
          @click="switchChapter(chapter_num + 1, 'chapter')">
          <span class="page-text">进入下一单元：{{intList[chapter_num].InductionName}}</span>
          <svg class="icon-svg icon-next">
            <use xlink:href="#icon-next" />
          </svg>
        </div>
      </div>
    </div>

    <!-- iframe弹窗 -->
    <div class="new-popupbox" v-if="iframeUrl">
      <div class="hanlder-box">
        <svg class="icon-svg popup-close" @click="iframeUrl = ''">
          <use xlink:href="#icon-guanbi" />
        </svg>
      </div>
      <LoadingOutlined class="iframe-loading" />
      <iframe id="iframe-box" ref="iframeBox" class="box-content iframe-content"  allowfullscreen="true" :src="iframeUrl" scrolling="no"
        frameborder="0" name="ifd" @load="listenIframeBox()"></iframe>
    </div>
  </div>
</template>

<script >
import { Empty } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { PASSPORT_CLIENT_SERVER } from '@/config/url';
import { ClassNameMap, BlockTypeMap } from '@/config/constant';

import headPath from '@/filter/headPath';
import pilotNav from '@/components/list/pilot-list/pilot-nav/pilot-nav.vue';
import noteBox from '@/components/list/pilot-list/note-box/note-box.vue';
import questionBox from '@/components/list/pilot-list/question-box/question-box.vue';
import pilotAchievement from '@/components/list/pilot-list/pilot-achievement/pilot-achievement.vue';

export default {
  name: 'pilot_list',
  components: {
    LoadingOutlined,
    pilotNav,
    pilotAchievement,
    noteBox,
    questionBox
  },
  props: {
    classInfo: Object,
    userScore: Object,
    intList: Array,
    stuList: Array,
  },
  data() {
    return {
      navFold: true,
      navMax: false,
      int: null,
      loading: true,
      chapter: null,
      chapter_num: null,

      userInfo: {},

      iframeUrl: '',
      locationUrl: '',
      platform_type: '',
      classId: '',

      allNote: [],
      noteData: [],
      questionData: [],
      loadNote: true,

      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  mounted() {
    this.locationUrl = window.location.href;
    let { platform, userInfo, currentClass } = this.$store.state;
    this.theme_color = platform.pageConfig.theme_color;
    this.platform_type = platform.Type;
    this.userInfo = userInfo;
    this.classId = currentClass.PK_ClassGuid;

    this.setHeight();
    const debounce = this.debounce(this.setHeight, 100);
    window.addEventListener('resize', debounce);

    if (this.intList.length == 0) return this.loading = false;
    this.switchChapter(0, 'chapter');

    this.findNoteList();
  },
  methods: {
    //设置各互动高度
    setHeight() {
      this.$nextTick(() => {
        const wWidth = window.innerWidth;
        const vWidth = $('.pilot-content-box').width();
        const vheight = (vWidth + 100) * (9 / 16);

        this.intList.forEach(int => {
          int.children.forEach(citem => {
            citem.data.forEach(code => {
              if (code.ProjectCode == 'cs' || code.ProjectCode == 'mi' || code.ProjectCode == 'intex') code.height = vheight;
              if (code.ProjectCode == 'kd') {

                let width = wWidth;
                if (this.navMax) width = wWidth - 330;

                code.style = {
                  width: `${width}px`,
                  left: `-${(wWidth - vWidth) / 2 + 70}px`
                }
              }
            })
          })
        })
      })
    },
    //移入移出
    mouseEvent(event) {
      if (this.folding) return;
      this.folding = true;
      setTimeout(() => {
        this.folding = false;
      }, 200);

      this.navFold = event;
    },
    //切换章节
    switchChapter(num, type) {
      if (num < 0) return this.$message.warning('没有上一页');
      else if (num > this.intList.length - 1) return this.$message.warning('已是最后一页');

      let chapter_num = this.chapter_num;
      if (num == chapter_num) return $('.scroll-box').animate({ scrollTop: 0 });

      this.loading = true;
      this.chapter_num = num;
      this.loadChapter(num);
      //互动初始高度
      this.intList.forEach((int, i) => {
        if (i == num) {
          if (!int.loadFinish) {
            int.children.forEach(citem => {
              citem.data.forEach(code => {
                if (this.platform_type == 'sz' && (code.ProjectCode == 'kb' || code.ProjectCode == 'kd')) code.fold = false;
              })
            })
            this.loadContent(int);
          }
          else {
            this.loading = false;
            if (type == 'chapter') $('.scroll-box').animate({ scrollTop: 0 })
          }
        }
      })
    },
    //加载内容
    loadContent(int) {
      //加载所有iframe
      this.$nextTick(async () => {
        setTimeout(() => {
          let scrollTop = $('.scroll-box').prop("scrollHeight");
          $('.scroll-box').animate({ scrollTop }, 1000);
        }, 500);
        setTimeout(() => {
          $('.scroll-box').animate({ scrollTop: 0 }, 1000);
        }, 1500);
        setTimeout(() => {
          this.loading = false;
          int.loadFinish = true;
        }, 3000);
      })
    },
    //加载前后章节
    loadChapter(num) {
      this.intList.forEach(int => { int.show = false })
      this.intList[num].show = true;
      if (num > 0) this.intList[num - 1].show = true
      if (num + 1 < this.intList.length) this.intList[num + 1].show = true;
    },
    //选择一个id
    chooseCode(id) {
      let code;
      this.intList.forEach(int => {
        int.children.forEach(citem => {
          citem.data.forEach(item => {
            if (item.Guid == id) code = item;
          })
        })
      })
      if (code) this.openCode(code);
    },
    //打开code
    openCode(code) {
      if (code.fold) this.foldCode(code);

      //是否加载章节并跳转
      let chapter_num = code.chapter_num;
      if (this.chapter_num != chapter_num) {
        this.switchChapter(chapter_num, 'code');

        this.intList.forEach((int, i) => {
          if (i == chapter_num) {
            if (int.loadFinish) this.scrollTo(code.Guid);
            else setTimeout(() => { this.scrollTo(code.Guid) }, 3000);
          }
        })
      }
      else this.scrollTo(code.Guid);
    },
    //折叠code
    foldCode(code) {
      this.judgeOnline();
      if (code.fold) {
        this.intList.forEach(int => {
          int.children.forEach(citem => {
            citem.data.forEach(item => {
              if (item.ProjectCode != 'kb' && item.ProjectCode != 'kd') item.fold = true;
            })
          })
        })
        code.fold = false;
      }
      else code.fold = true;

      if (code.ProjectCode == 'cs' && code.fold == false && !code.listen_mouseenter) {
        this.stopIframe(code);
      }
    },
    //打开iframe
    openIframe(code) {
      let token = this.userInfo.token;
      if (code.ProjectCode == "rpa") {
        let url = code.address.replace("${token}", token);
        window.open(url);
      }
      else this.iframeUrl = code.phoneIframe;
      code.fold = true;
    },
    //滚动到code
    scrollTo(id) {
      this.$nextTick(async () => {
        if ($(`#${id}`).offset()) {
          let scrollTop = $(`.scroll-box`).scrollTop() + $(`#${id}`).offset().top - 30;
          $('.scroll-box').animate({ scrollTop }, 300);
        }
      })
    },
    //监听iframe传值
    listenIframe(code) {
      if (code.listener) return;
      let that = this;

      this.$nextTick(() => {
        let iframe = that.$refs[code.Guid];
        //判断是不是数组
        if (Array.isArray(iframe)) iframe = iframe[0];

        //发送值
        iframe.contentWindow.postMessage({
          command: 'postStudentId',
          data: {
            studentId: this.userInfo.PK_UserGuid,
          },
        }, '*')
        //接受值
        code.listener = window.addEventListener('message', function (e) {
          if (e.source != iframe.contentWindow) return;
          let data = e.data || { height: 600 };
          //console.log(code.Title + '：' + data.height)
          let needChange = Math.abs(data.height - code.height) > 50 ? true : false;
          if (data && data.command == "updateHeight" && needChange) {
            code.height = data.height + 10;
          }
        })
      })
    },
    //监听iframe弹窗
    listenIframeBox() {
      let that = this;
      this.$nextTick(() => {
        let iframe = that.$refs["iframeBox"];
        //发送值
        iframe.contentWindow.postMessage({
          command: 'postStudentId',
          data: {
            studentId: this.userInfo.PK_UserGuid,
          },
        }, '*')
      })
    },

    //阻止事件
    stopIframe(code) {
      let w_width = window.innerWidth;
      if (w_width <= 600) return;

      $('.scroll-box').css('overflow-y', 'hidden');

      setTimeout(() => {
        let iframe = this.$refs[code.Guid];
        code.listen_mouseenter = iframe.addEventListener('mouseenter', function () {
          $('.scroll-box').css('overflow-y', 'hidden')
        })

        code.listen_mouseleave = iframe.addEventListener('mouseleave', function () {
          $('.scroll-box').css('overflow-y', 'overlay')
        })
      }, 100);
    },
    //固定菜单
    swichNavMax(event) {
      this.navMax = event;
      this.setHeight();
    },
    //折叠菜单
    foldNav(event) {
      this.mouseEvent(event);
    },

    //判断用户是否在线
    async judgeOnline() {
      const ret = await this.$api.unifydata.verifyToken({ token: this.userInfo.token });
      if (ret.statusCode != 200) location.href = `${PASSPORT_CLIENT_SERVER}/yuanxi?redirectURI=${location.href}`;
    },
    //防抖
    debounce(fn, delay) {
      let timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn();
        }, delay);
      }
    },
    //////////////////////////////////////获取笔记
    //获取note
    async findNoteList() {
      let res = await this.$api.note.findList(this.classId);
      if (res.statusCode != 200) return this.$message.warning(res.message);

      this.allNote = res.data || [];

      let noteList = [];
      let allStuList = [];
      
      //处理数据
      res.data.forEach(item => {
        if (allStuList.indexOf(item.fk_studentId) == -1) allStuList.push(item.fk_studentId);
        item.notes.forEach(note => {
          noteList.push({
            fk_studentId: item.fk_studentId,
            fk_trainId: item.fk_trainId,
            fk_unitId: item.fk_unitId,
            _id: item._id,
            uid: note.uid,
            text: note.text || BlockTypeMap[note.blockType],
            content: note.content,
            public: note.public,
            themeColor: ClassNameMap[note.className] || '#66666',
            bakColor: ClassNameMap[note.className] ? ClassNameMap[note.className] + 40 : '#6666640',
            noteType: note.noteType,
            updateTime: note.updateTime,
            isMine: item.fk_studentId == this.userInfo.PK_UserGuid,
            comments: note.comments || []
          })

          //找到评论学生
          if (note.comments) {
            note.comments.forEach(comment => {
              if (allStuList.indexOf(comment.studentId) == -1) allStuList.push(comment.studentId);
              comment.isMine = comment.studentId == this.userInfo.PK_UserGuid;
            })
          }
        })
      })

      //获取用户信息
      let userList = [];
      if (allStuList.length > 0) {
        let userIdList = JSON.stringify(allStuList).replace('[', '').replace(']', '');
        userList = await this.$api.note.getStudentUser(userIdList).then(res => res.data || []);
        userList.forEach(user => {
          user.name = user.NickName || user.Name;
          user.headPhotoPath = headPath(user.HeadPhotoPath);
        })
      }

      let newReply = 0;
      noteList.forEach(note => {
        let user = userList.find(item => item.PK_UserGuid == note.fk_studentId);
        if (user) {
          note.userName = user.name;
          note.headPhotoPath = user.headPhotoPath;
        }

        //匹配回复
        note.comments.forEach(comment => {
          let user = userList.find(item => item.PK_UserGuid == comment.studentId);
          if (user) {
            comment.userName = user.name;
            comment.headPhotoPath = user.headPhotoPath;

            if (comment.isNew && note.isMine && !comment.isMine) newReply += 1;
          }
        })
      })
      if (newReply > 0) this.$store.commit('newReply', newReply);

      this.noteData = noteList.filter(item => item.noteType != 'question');
      this.questionData = noteList.filter(item => item.noteType == 'question');
      this.loadNote = false;
    }
  },
  //组件销毁
  beforeUnmount() {
    //解除所有监听
    this.intList.forEach(int => {
      int.children.forEach(citem => {
        citem.data.forEach(code => {
          if (code.listener) window.removeEventListener('message', code.listener)
          if (code.listen_mouseenter) window.removeEventListener('mouseenter', code.listen_mouseenter)
          if (code.listen_mouseleave) window.removeEventListener('mouseleave', code.listen_mouseleave)
        })
      })
    })

    const debounce = this.debounce(this.setHeight, 100);
    window.removeEventListener('resize', debounce);
  }
}


</script>

<style scoped lang="scss">
@import "./pilot-list.scss";
</style>